import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LinksPage from "@/pages/LinksPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LinksPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
